import { apiClient, type ApiResponse } from './client'

export type SearchType = 'both' | 'title' | 'content'
export type CategoryFilter = 'all' | 'pinned' | 'normal'

export interface PublicAnnouncementSummary {
  announcementId: number
  title: string
  status: string
  isPinned: boolean
  isGlobal: boolean
  targetAppTypes?: string[] | null
  targetAudience?: string | null
  source: string
  authorName: string | null
  viewCount: number
  publishStartAt: string | null
  createdAt: string
  updatedAt: string
}

export interface PublicAnnouncement {
  announcementId: number
  title: string
  content: string
  contentFormat: string
  status: string
  publishStartAt: string | null
  publishEndAt: string | null
  isPinned: boolean
  isGlobal: boolean
  targetAppTypes?: string[] | null
  targetAudience?: string | null
  source: string
  authorId: number
  authorName: string | null
  viewCount: number
  createdAt: string
  updatedAt: string
}

export interface PublicAnnouncementListResponse {
  announcements: PublicAnnouncementSummary[]
  totalCount: number
  page: number
  size: number
  totalPages: number
}

const APP_TYPE = 'lc'

export const publicAnnouncementApi = {
  getList: async (params: {
    page: number
    size: number
    keyword?: string
    searchType?: SearchType
    category?: CategoryFilter
  }): Promise<PublicAnnouncementListResponse> => {
    const response = await apiClient.get<ApiResponse<PublicAnnouncementListResponse>>(
      '/v1/public/announcements/homepage',
      {
        params: {
          appType: APP_TYPE,
          page: params.page,
          size: params.size,
          searchType: params.searchType ?? 'both',
          category: params.category ?? 'all',
          ...(params.keyword ? { keyword: params.keyword } : {}),
        },
      },
    )
    if (!response.data.data) throw new Error('Failed to fetch announcements')
    return response.data.data
  },

  getById: async (id: number): Promise<PublicAnnouncement> => {
    const response = await apiClient.get<ApiResponse<PublicAnnouncement>>(
      `/v1/public/announcements/homepage/${id}`,
    )
    if (!response.data.data) throw new Error('Announcement not found')
    return response.data.data
  },
}
